export default __webpack_public_path__ + "static/media/arrow-return.f0d59236.svg";